
























export default {
  name: 'attachmentsUploadPreview',
  props: {
    files: {
      type: Array,
      required: true,
      default: (): any => {
        return [];
      }
    },
  },
  methods: {
    computeAttachmentItemComponentClass(file: any) {
      return {
        'tc--b-widget__attachments-item--uploading': file.status === 'uploading',
        'tc--b-widget__attachments-item--image': file.type.includes('image'),
        'tc--b-widget__attachments-item--file': !file.type.includes('image')
      };
    },
    removeItem(index: Number, fileId: string) {
      this.$emit('removeItem', index, fileId);
    },
    checkFileNameLength(file: any) {//if the file name size bigger than container append file extension
      if (file && file.name.length > 12) {
        return '.' + this.documentTypeExtension(file.fileExtension) || null;
      } else {
        return '';
      }
    },
    documentTypeExtension(type: string) {//view doc extension name
      if (type && type.includes("vnd.openxmlformats-officedocument.wordprocessingml.document")) {
        return 'doc';
      } else {
        return type;
      }
    },
  }
};
